import { getImageUrl, isImage, OneMedia } from '@prismamedia/one-components';
import { MediaBlock } from '../../types/draft';

export const getNlFlashImageUrl = (
  medias: OneMedia[] | null | undefined,
  slidesIndex: string[],
  slideMap: Record<string, MediaBlock>,
): string | undefined => {
  const firstMedia = medias?.find((media) => isImage(media));
  if (firstMedia) {
    return getImageUrl(firstMedia);
  }

  const [firstSlideKey] = slidesIndex;
  const firstSlide = firstSlideKey ? slideMap[firstSlideKey] : undefined;
  if (firstSlide?.data?.iframely) {
    return getImageUrl(firstSlide.data);
  }

  return undefined;
};
